module.exports = __webpack_public_path__ + "img/Sardinija.4ad56ea8.png";